'use client';

import { c as _c } from "react/compiler-runtime";
import { type SearchedGoal } from '@shared/all/domains/factiiis';
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { client } from '../../utils/trpc';
import Avatar from '../common/Avatar';
import Error from '../common/Error';
type Props = {
  query: string;
  goalClickHandler: (factiii: SearchedGoal) => void;
};
const GoalSearchSuggestions = props => {
  const $ = _c(11);
  let t0;
  if ($[0] !== props.query) {
    t0 = {
      queryKey: ["goals", props.query],
      queryFn: () => unwrapFromResult(client.search.goals.query({
        query: props.query
      })),
      staleTime: 0
    };
    $[0] = props.query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    isLoading,
    isError,
    data
  } = useQuery(t0);
  let t1;
  if ($[2] !== data?.factiiis || $[3] !== props) {
    t1 = data?.factiiis?.map(factiii => <div key={factiii.id} className="flex rounded-md border-2 border-ds-border-subtle p-4 hover:bg-background-light" onClick={() => props.goalClickHandler(factiii)}><Avatar spaceAvatarKey={factiii.avatarKey} size={40} /><div className="ml-2"><p>{factiii.name}</p><p className="text-textSecondary/70">s/{factiii.spaceSlug ? factiii.spaceSlug + "/" : ""}{factiii.slug}</p></div></div>);
    $[2] = data?.factiiis;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isError || $[6] !== isLoading) {
    t2 = <Error error={isError} loading={isLoading} />;
    $[5] = isError;
    $[6] = isLoading;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="absolute z-50 flex h-56 w-full max-w-[570px] flex-col gap-2 overflow-y-auto rounded-md border-2 border-ds-border-standard bg-background-primary p-4">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default GoalSearchSuggestions;